<template>
    <VVVLayoutNew>
        <template #page-title>
            Create User Account
        </template>
        <nav aria-label="breadcrumb" style="font-size: 13px;">
            <MDBBreadcrumb>
                <MDBBreadcrumbItem><router-link to="/users" style="cursor: default; color: var(--primary); font-size: 14px;">Users</router-link>
                </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active style="cursor: default; font-size: 14px;">
                    Create User Account
                </MDBBreadcrumbItem>
            </MDBBreadcrumb>
        </nav>
        <div class="backdrop" v-if="loadingSpinner">
            <div class="image-container d-flex justify-content-center align-items-center">
                <div class="loader"></div>
                <img src="@/assets/VVV/vvv-loader.png" alt="Loading image">
            </div>
        </div>
        <MDBCard id="UserInformation" class="shadow account-form  m-auto" tag="form" @submit.prevent="submit">
            <MDBCardHeader class="py-3">
                <h5 class="fw-bold mb-0">Account Information</h5>
            </MDBCardHeader>
            <MDBCardBody class="d-flex flex-column" style="gap: 15px">
                <div>
                    Email:
                    <MDBInput class="mt-1" type="email" v-model="form.email" />
                </div>
                <div>
                    Partner Percentage:
                    <MDBInput class="mt-1" type="number" placeholder="Partner Percentage" v-model="partnerPercentage" />
                </div>
                <div>
                    Google Sheet Info:
                    <MDBInput label="Google Sheet Link" type="text" v-model="form.googleSheetLink" class="mt-3" />
                    <MDBInput label="Google Sheet Name" type="text" v-model="form.sheetName" class="mt-4" />
                </div>
                <div class="mt-2">
                    <MDBBtn class="fw-bold" type="button" color="primary" aria-controls="assetLabelModal"
                        @click="assetLabelModal = true" size="sm">
                        Select Asset Label/s
                    </MDBBtn>
                    <MDBTable hover class="mt-3">
                        <thead class="table-light align-middle">
                            <tr>
                                <th v-for="(item, i) in tableHeaders" :key="i" scope="col" class="py-3 px-4">
                                    {{ item.header }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="selectedAssetLabelsArray.length < 1">
                            <tr class="align-middle">
                                <td colspan="3">
                                    No asset label selected.
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="selectedAssetLabelsArray.length > 0">
                            <tr v-for="(item, i) in selectedAssetLabelsArray" :key="i" class="align-middle">
                                <td class="align-middle">{{ item.name }}</td>
                                <td class="align-middle" style="width: 45%;">
                                    <select v-model="item.assignedDashboard" class="form-select">
                                        <option v-for="option in dashboard" :key="option.value" :value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </td>
                                <td class="d-flex justify-content-end text-right p-4">
                                    <MDBBtn color="danger" floating @click.stop.prevent="clickDelete(item)" size="sm">
                                        <em class="far fa-trash-alt" />
                                    </MDBBtn>
                                </td>
                            </tr>
                        </tbody>
                    </MDBTable>
                </div>
            </MDBCardBody>
            <MDBCardFooter class="py-3 px-4 d-flex justify-content-end">
                <MDBBtn class="fw-bold" type="submit" color="primary" :disabled="isInviteBtnDisabled" size="sm">
                    Invite User
                </MDBBtn>
            </MDBCardFooter>
        </MDBCard>
     <MDBModal
  id="assetLabelModal"
  tabindex="-1"
  labelledby="assetLabelModalLabel"
  v-model="assetLabelModal"
  scrollable
  :static-backdrop="true"
>
  <MDBModalHeader class="px-4">
    <MDBModalTitle class="fw-bold" id="assetLabelModalLabel">Asset Labels</MDBModalTitle>
  </MDBModalHeader>

  <MDBModalBody class="pb-0 px-4">

    <!-- Top Row: Search + Add/Delete buttons -->
    <div class="d-flex justify-content-between align-items-center mb-3">

      <!-- Search Input -->
      <MDBInput
        label="Search Asset Label"
        v-model="dataTableSearch"
        class="w-75"
      />

      <!-- Add / Delete Buttons -->
      <div v-if="canEditAssetLabels" class="d-flex gap-2">
        <MDBBtn
          color="success"
          size="sm"
          class="fw-bold"
          @click="openAddAssetLabel"
        >
          <i class="fas fa-plus me-1"></i> Add
        </MDBBtn>

        <MDBBtn
          color="danger"
          size="sm"
          class="fw-bold"
          :disabled="usersStore.assetLabels.length === 0"
          @click="deleteSelectedAssetLabels"
        >
          <i class="fas fa-trash-alt me-1"></i> Delete
        </MDBBtn>
      </div>
    </div>

    <!-- Datatable Row (Separated for alignment) -->
    <div>
      <MDBDatatable
        :dataset="assetLabelDataTable"
        selectable
        multi
        :search="dataTableSearch"
        @selected-rows="handleSelectedRow($event)"
        hover
      />
    </div>

  </MDBModalBody>

  <MDBModalFooter class="gap-2 py-3 px-4">
    <MDBBtn class="fw-bold" size="sm" @click="assetLabelModal = false">Close</MDBBtn>

    <MDBBtn class="fw-bold" size="sm" color="primary" @click="assetLabelModal = false">
      Select Asset Labels
    </MDBBtn>
  </MDBModalFooter>
</MDBModal>

                <MDBModal id="addAssetLabelModal" v-model="addAssetLabelModal" :static-backdrop="true" centered>
            <MDBModalHeader class="px-4">
                <MDBModalTitle class="fw-bold">Add New Asset Label</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody class="px-4">
                <MDBInput label="Asset Label Name" v-model="newAssetLabelName" />
            </MDBModalBody>
            <MDBModalFooter class="gap-2 py-3 px-4">
                <MDBBtn class="fw-bold" size="sm" @click="addAssetLabelModal = false">Cancel</MDBBtn>
                <MDBBtn class="fw-bold" size="sm" color="primary" @click="submitNewAssetLabel">Add</MDBBtn>
            </MDBModalFooter>
        </MDBModal>
        <DeductionsToast />
                <MDBToast v-model="toastObject.state" :delay="2000" autohide position="top-right" appendToBody stacking
            width="350px" :color="toastObject.color" text="white" :icon="toastObject.icon">
            <template #title>
                {{ toastObject.title }}
            </template>
            {{ toastObject.message }}
        </MDBToast>
        <MDBToast v-model="errorToast" :delay="2000" autohide position="top-right" appendToBody stacking width="350px"
            color="danger" text="white" icon="fas fa-check fa-lg me-2">
            <template #title> Error </template>
            {{ errorToastMessage }}
        </MDBToast>
    </VVVLayoutNew>
</template>

<script setup>
import DeductionsToast from "@/components/Deductions/DeductionsToast.vue";
import { PostInviteUser } from "@/services/Users/PostInviteUser";
import { useToastStore } from "@/store/toastStore";
import VVVLayoutNew from "@/views/VVVNew/VVVLayoutNew.vue";
import { useTitle } from "@vueuse/core";
import axios from "axios";
import { MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBDatatable, MDBInput, MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBTable, MDBToast} from "mdb-vue-ui-kit";
import { computed, onBeforeMount, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { useUsersStore } from "@/store/usersStore";
import { useUserDetailStore } from "../../../store/userDetailStore";
useTitle("Create User Account | Very Viral Videos");

const router = useRouter();
const usersStore = useUsersStore();
const assetLabelModal = ref(false);
const toastStore = useToastStore();
const userDetailStore = useUserDetailStore();
const errorToast = ref(false);
const assetToDelete = ref([]);
const { userDetail } = storeToRefs(userDetailStore);
const errorToastMessage = ref("Error");
const addAssetLabelModal = ref(false);
const newAssetLabelName = ref("");
const openAddAssetLabel = () => {
    newAssetLabelName.value = "";
    addAssetLabelModal.value = true;
};

const toastObject = ref({
    state: false,
    message: "",
    color: "",
    icon: "",
    title: "",
});



const allowedEmails = [
    "copyright@enfinity.com",
    "meg@enfinity.co",
    "juris@enfinity.co",
]

const canEditAssetLabels = computed(() => {
  return userDetail.value.email && allowedEmails.includes(userDetail.value.email);
});

const assetLabelDataTable = ref({
    columns: [{ label: "Name", field: "name" }],
    rows: [],
});

const tableLoader = ref(false);
const dataTableSearch = ref("");
const partnerPercentage = ref(0);

onBeforeMount(async () => {
    assetLabelDataTable.value.rows = [];
    tableLoader.value = true;
    await axios.get("api/assetLabels/Dropdown").then(function (data) {
        assetLabelDataTable.value.rows = data.data;
        tableLoader.value = false;
    });
});

const deleteSelectedAssetLabels = async () => {
    try {
        const deleteAssets = assetToDelete.value; // all selected items
        const deletedIds = deleteAssets.map(a => a.id);

        for (const item of deleteAssets) {
            // Call your API for each asset
            await axios.patch(`/api/AssetLabels/${item.id}/Assets`);

            // Remove this item from usersStore.assetLabels immediately
            usersStore.assetLabels = usersStore.assetLabels.filter(
                (element) => element.id !== item.id
            );
        }

        // Also remove deleted items from the datatable rows
        usersStore.assetLabelDataTable.rows = usersStore.assetLabelDataTable.rows.filter(
            row => !deletedIds.includes(row.id)
        );
        const res = await axios.get("api/assetLabels/Dropdown");
            assetLabelDataTable.value.rows = res.data;
            usersStore.assetLabelDataTable = {
                ...usersStore.assetLabelDataTable,
                rows: res.data, // <-- forces table refresh
            };

        toastObject.value = {
            state: true,
            message: "Selected asset labels deleted successfully.",
            color: "success",
            icon: "fas fa-check-circle fa-lg me-2"
        };
    } catch (error) {
        toastObject.value = {
            state: true,
            message: "Error deleting asset labels: " + error,
            color: "danger",
            icon: "fas fa-exclamation-circle fa-lg me-2"
        };
    }
};

const handleSelectedRow = (selectedModalArray) => {
    assetToDelete.value = [...selectedModalArray];
    const newArray = selectedModalArray.map(label => ({
        ...label,
        assignedDashboard: label.assignedDashboard || 1,
    }));
    selectedAssetLabelsArray.value = newArray;
    usersStore.assetLabels = newArray;
};

const clickDelete = (item) => {
    const newArray = selectedAssetLabelsArray.value.filter(
        (element) => element.id != item.id
    );
    selectedAssetLabelsArray.value = newArray;
};

let loadingSpinner = ref(false);

const selectedAssetLabels = ref("");
const selectedAssetLabelsArray = ref([]);
watch([selectedAssetLabels], ([newSelectedAssetLabels]) => {
    selectedAssetLabelsArray.value = newSelectedAssetLabels.split(",");
});

const form = reactive({
    email: "",
    link: null,
    googleSheetLink: "",
    sheetName: "",
    assignedDashboard: 1,
});

const tableHeaders = computed(() => [
    {
        header: "Name",
    },
    {
        header: "Dashboard",
    },
    {},
]);

const isInviteBtnDisabled = computed(
    () => form.email == "" || partnerPercentage.value == ""
);

const submit = async () => {
    const formData = {
        email: form.email,
        userTypeId: 3,
        googleSheetLink: form.googleSheetLink != "" ? form.googleSheetLink : null,
        sheetName: form.sheetName != "" ? form.sheetName : null,
        assignedAssetLabels: selectedAssetLabelsArray.value.map(label => ({
            id: label.id,
            assignedDashboard: label.assignedDashboard,
        })),
        partnerPercentage: partnerPercentage.value,
    };

    loadingSpinner.value = true;
    const toastSuccess = {
        ...toastStore.toastStatus.success,
        ...{
            message: "Successfully invited!",
        },
    };
    await PostInviteUser(formData)
        .then(() => {
            toastStore.toastObject = {
                ...toastStore.toastObject,
                ...toastSuccess,
            };
        })
        .catch((response) => {
            if (response.status != 200 || response.status != 201) {
                toastStore.toastObject = {
                    ...toastStore.toastObject,
                    ...toastStore.toastStatus.fail,
                };
            }
        })
        .finally(() => {
            loadingSpinner.value = false;
            router.push({ name: "UserManagement" });
        });
};

const dashboard = ref([
    { text: 'Creator Shield & Very Viral Videos', value: 1 },
    { text: 'Creator Shield', value: 2 },
    { text: 'Very Viral Videos', value: 3 },
]);

const submitNewAssetLabel = async () => {
    if (!newAssetLabelName.value.trim()) {
        errorToastMessage.value = "Please enter a valid asset label name.";
        errorToast.value = true;
        return;
    }

    try {
        const response = await axios.post("api/assetLabels", { name: newAssetLabelName.value.trim() });
        if (response.status === 200 || response.status === 201) {
            toastObject.value = {
                title: "Success!",
                state: true,
                message: "Asset label added successfully.",
                color: "success",
                icon: "fas fa-check fa-lg me-2",
            };
            // Refresh asset labels
            const res = await axios.get("api/assetLabels/Dropdown");
            assetLabelDataTable.value.rows = res.data;
            usersStore.assetLabelDataTable = {
                ...usersStore.assetLabelDataTable,
                rows: res.data, // <-- forces table refresh
            };
            addAssetLabelModal.value = false;
        }
    } catch (error) {
        errorToastMessage.value = "Failed to add asset label.";
        errorToast.value = true;
    }
};
</script>

<style scoped>
.btn-primary {
    background-color: var(--primary);
}

.btn-secondary {
    background-color: var(--accent);
}

.card,
.card-body {
    overflow-y: auto;
}

.image-container {
    position: relative;
    display: inline-block;
}

.image-container .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--primary);
    border-radius: 50%;
    animation: BorderSpin 1s linear infinite;
}

.image-container img {
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

@keyframes BorderSpin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.account-form {
    width: 70%
}

@media screen and (max-width: 767px) {
    .account-form {
        width: 100%
    }
}
</style>
